import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate, useParams } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'
import dayjs from "dayjs";
import { loadStripe } from "@stripe/stripe-js";
import {
    Elements,
    useStripe,
    useElements,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
} from "@stripe/react-stripe-js";
import StripePaymentModal from "./stripe-payment-modal";




const GuestIntakeFormReview = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsisLoading] = useState(false);

    const [showStripeModal, setShowStripeModal] = useState(false);
    const [stripePromise, setStripePromise] = useState(null);
    const [stripeModalData, setStripeModalData] = useState(null);


    const [selectedItemId, setSelectedItemId] = useState("");
    const [guestItems, setGuestItems] = useState([]); // array of added items
    const [discountItemIndex, setDiscountItemIndex] = useState(null);
    const [showItemDiscountModal, setShowItemDiscountModal] = useState(false);
    const [discountValue, setDiscountValue] = useState("");
    const [additionalItems, setAdditionalItems] = useState([]);
    const [monthlyRows, setMonthlyRows] = useState([]);
    const [monthlyDiscountModalIndex, setMonthlyDiscountModalIndex] = useState(null);
    const [monthlyDiscountValue, setMonthlyDiscountValue] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);

    const [isPaid, setIsPaid] = useState(false);


    const [review, setReview] = useState({
        id: id,
        discount: 0,
        mode_of_payment: 'offline',
    });

    // Load data on mount
    useEffect(() => {
        getGuest();
        getAdditionalItems();
        // setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY));

    }, []);




    const getGuest = async () => {
        setIsisLoading(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-guest/${id}`,
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            const guest = response.data?.guest;
            setReview(guest);

            setIsPaid((guest?.monthly_rents?.length > 0 && guest?.monthly_rents[0].payment_id));


            // Load saved monthly rent rows or generate if not present
            let months = [];
            if (guest.monthly_rents && guest.monthly_rents.length) {
                months = guest.monthly_rents.map(row => ({
                    month: dayjs(row.month.replace(/-00$/, "-01")).format("MMM YYYY"),
                    discount: parseFloat(row.discount || 0)
                }));
            } else {
                months = Array.from({ length: guest.current_invoice_period || 1 }, (_, i) => ({
                    month: dayjs().add(i, 'month').format("MMM YYYY"),
                    discount: 0
                }));
            }
            setMonthlyRows(months);

            // Load saved additional items if exist

            if (guest.additional_items && guest.additional_items.length) {
                const mappedItems = guest.additional_items.map(ai => ({
                    id: ai.id,
                    name: ai.name,
                    description: ai.description,
                    rate: parseFloat(ai.rate),
                    discount: parseFloat(ai.discount || 0),
                }));
                setGuestItems(mappedItems);
            }
            else {
                setGuestItems([]);
            }

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to load guest information",
            });
        } finally {
            setIsisLoading(false);
        }
    };


    const getAdditionalItems = () => {
        setIsisLoading(true);
        axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-additional-items`, {
            withCredentials: true
        })
            .then(res => {
                setAdditionalItems(res.data.additionalItems || []);
                setIsisLoading(false);
            })
            .catch((error) => {
                setIsisLoading(false);
                globalErrorHandler(error, navigate);

            });
    };



    const handleAddItem = () => {
        const selected = additionalItems.find(ai => ai.id == selectedItemId);
        if (!selected) return;

        setGuestItems([...guestItems, {
            ...selected,
            discount: 0
        }]);
        setSelectedItemId("");
    };




    const openItemDiscountModal = (index) => {
        setDiscountItemIndex(index);
        setDiscountValue(guestItems[index].discount || "");
        setShowItemDiscountModal(true);
    };

    const applyItemDiscount = () => {
        const updated = [...guestItems];
        const item = updated[discountItemIndex];

        const discount = parseFloat(discountValue) || 0;

        if (discount >= item.rate) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Discount',
                text: 'Discount must be less than the item amount.',
            });
            return;
        }

        item.discount = discount;
        setGuestItems(updated);
        setShowItemDiscountModal(false);
    };



    const applyMonthlyDiscount = () => {
        const updated = [...monthlyRows];
        const row = updated[monthlyDiscountModalIndex];
        const discount = parseFloat(monthlyDiscountValue) || 0;

        console.log(review);
        if (discount >= review?.monthly_rate) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Discount',
                text: 'Discount must be less than the monthly amount.',
            });
            return;
        }

        row.discount = discount;
        setMonthlyRows(updated);
        setMonthlyDiscountModalIndex(null);
    };

    const handleCancelAndDiscard = async () => {

        const payload = {

            guest_id: review?.id,
            monthly_rents: [],
            additional_items: [],
            mode_of_payment: null
        };

        try {
            setIsDisabled(true);

            const response = await axios.post(
                `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/save-guest-payment`,
                payload,
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            if (response.data.status) {
                Swal.fire("Success", "Guest payment data cleared.", "success");
                getGuest();
            }
            setIsDisabled(false);

        } catch (err) {
            console.error(err);
            setIsDisabled(false);

            Swal.fire("Error", "Something went wrong while saving.", "error");
        }
    };

    const handleSaveAndNext = async () => {



        const { mode_of_payment } = review;


        if (!mode_of_payment) {
            Swal.fire("Missing Fields", "Please enter mode of payment.", "warning");
            return;
        }
        setIsDisabled(true);

        const payload = {
            guest:{id:review?.id,name: review.name, email: review.email, phone: review.phone,user_id: review.user_id, bed_id: review.bed_id, move_in_date: review.move_in_date,monthly_rate:review.monthly_rate, is_recurring:review.is_recurring}, 
            guest_id: review?.id,
            monthly_rents: monthlyRows.map(row => ({
                month: row.month,                     // e.g. '2025-07-01'
                rate: parseFloat(review?.monthly_rate || 0),
                discount: parseFloat(row.discount || 0),
            })),
            additional_items: guestItems.map(item => ({
                additional_item_id: item.id,
                rate: parseFloat(item.rate || 0),
                discount: parseFloat(item.discount || 0),
            })),
            mode_of_payment: review?.mode_of_payment,
                                is_recurring: review?.is_recurring || 0,


        };

        try {

            if (mode_of_payment === 'offline') {

                const response = await axios.post(
                    `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/save-guest-payment`,
                    payload,
                    {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: true,
                    }
                );

                if (response.data.status) {
                    Swal.fire("Success", "Guest payment data saved.", "success");
                    navigate(`/admin/guest-management/guest`);
                } else {
                    Swal.fire("Error", response.data.message || "Failed to save data.", "error");
                }
            }
            else if (mode_of_payment === "online") {
                setStripeModalData(payload);  // ✅ prepare data for Stripe modal
                setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)); // ✅ lazy-load Stripe
                setShowStripeModal(true);
            }
            setIsDisabled(false);

        } catch (err) {
            setIsDisabled(false);
            console.error(err);
            Swal.fire("Error", "Something went wrong while saving.", "error");
        }



    };


    const handleStripeSuccess = async (paymentMethodId) => {
        try {
            setIsDisabled(true);
            
            const payload = {
                ...stripeModalData,               // ✅ everything user prepared
                payment_method_id: paymentMethodId,
                mode_of_payment: "online",
            };

            const response = await axios.post(
                `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/save-guest-payment`,
                payload,
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            if (response.data.status) {
                Swal.fire("Success", "Payment completed successfully.", "success");
                setShowStripeModal(false);
                navigate(`/admin/guest-management/guest`);
            } else {
                Swal.fire("Error", response.data.message || "Payment failed.", "error");
            }
                        setIsDisabled(false);

        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Something went wrong while processing payment.", "error");
        }
    };

    const handleStripePayment = async (paymentMethodId) => {
        const payloadWithStripe = {
            ...stripeModalData,
            payment_method_id: paymentMethodId
        };

        //   const response = await axios.post('/save-guest-payment', payloadWithStripe, {...});
        const response = await axios.post(
            `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/save-guest-payment`,
            payloadWithStripe,
            {
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
            }
        );

        if (response.data.status) {
            Swal.fire("Success", "Payment completed and saved!", "success");
            setShowStripeModal(false);
            navigate(`/admin/guest-management/guest`);
        } else {
            Swal.fire("Error", response.data.message || "Failed to save data.", "error");
        }




    };

    const getTotalSubtotal = () => {
        const baseRate = parseFloat(review?.monthly_rate || 0);
        const rentSubtotal = monthlyRows.reduce((total, row) => total + baseRate, 0);
        const itemSubtotal = guestItems.reduce((total, item) => total + parseFloat(item.rate || 0), 0);
        return (rentSubtotal + itemSubtotal).toFixed(2);
    };

    const getTotalDiscount = () => {
        const rentDiscount = monthlyRows.reduce((total, row) => total + parseFloat(row.discount || 0), 0);
        const itemDiscount = guestItems.reduce((total, item) => total + parseFloat(item.discount || 0), 0);
        return (rentDiscount + itemDiscount).toFixed(2);
    };

    const getTotalAmountPaid = () => {
        const subtotal = parseFloat(getTotalSubtotal());
        const discount = parseFloat(getTotalDiscount());
        return (subtotal - discount).toFixed(2);
    };


    if (isLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">isLoading...</span>
                </div>
            </div>
        );
    }



    return (
        <div className="container-fluid px-4 mt-4 mb-5  " id="guest-main">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0">Guest Intake Form</h3>
            </div>


            <div className="row mb-4" >
                <div className="col-lg-3 d-flex flex-row align-items-center fw-bold"><div className="icon-circle me-2"><i className="bi bi-briefcase-fill"></i></div>Details</div>
                <div className="col-lg-3 d-flex flex-row align-items-center fw-bold "><div className="icon-circle me-2"><i className="bi bi-person-fill"></i></div>Move-In</div>
                <div className="col-lg-3 d-flex flex-row align-items-center fw-bold "><div className="icon-circle me-2"><i className="bi bi-file-earmark-check-fill"></i></div>Review</div>
                <div className="col-lg-3 d-flex flex-row align-items-center fw-bold text-secondary"><div className="icon-circle me-2"><i className="bi bi-credit-card-fill"></i></div>Pay</div>

            </div>

            <div className="card shadow mt-4">
                <div className="card-header">
                    <h5 className="mb-0">Finalize and add Additional Items</h5>
                </div>
                <div className="card-body p-4">

                    <div className="row g-4">

                        <div className="col-lg-6 d-flex align-items-center fw-bold">
                            <i className="bi bi-house-door-fill me-2"></i> {review?.property_name}, {review?.floor_name}
                        </div>

                    </div>


                    <div className="row g-4 my-4 ">
                        <div className="col-lg-12">

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th>Bed</th>
                                        <th>Bed Type</th>
                                        <th>Month</th>
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>Subtotal</th>
                                    </tr>
                                    {monthlyRows.map((row, index) => (
                                        <tr key={index}>
                                            <td>{review?.bed_id}</td>
                                            <td>{review?.bedtypename}</td>
                                            <td>{row.month}</td>
                                            <td>${parseFloat(review?.monthly_rate).toFixed(2)}</td>
                                            <td>
                                                {!isPaid ?
                                                    <>
                                                        {!row.discount ? (
                                                            <button className="btn btn-outline-success btn-sm" onClick={() => {
                                                                setMonthlyDiscountModalIndex(index);
                                                                setMonthlyDiscountValue("");
                                                            }}>
                                                                <i className="bi bi-plus-lg me-1"></i>Add Discount
                                                            </button>
                                                        ) : (
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="text-success fw-bold mb-0">${row.discount}</span>
                                                                <button
                                                                    className="btn btn-sm btn-outline-danger py-0 px-2"
                                                                    onClick={() => {
                                                                        const updated = [...monthlyRows];
                                                                        updated[index].discount = 0;
                                                                        setMonthlyRows(updated);
                                                                    }}
                                                                >
                                                                    <i className="bi bi-x-lg"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                    :
                                                    <span className="text-success fw-bold mb-0">${row.discount}</span>

                                                }
                                            </td>
                                            <td>${(parseFloat(review?.monthly_rate) - (row.discount || 0)).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>
                    </div>


                    <div className="row g-4">

                        <div className="col-lg-12 d-flex align-items-center fw-bold">
                            <i class="bi bi-basket2-fill me-2"></i>  Additional Items
                        </div>

                    </div>



                    <div className="row g-4 my-4 ">
                        <div className="col-lg-12">

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th>Item</th>
                                        <th>Description</th>
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>Subtotal</th>
                                    </tr>
                                    {guestItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                {!isPaid && (
                                                    <button
                                                        className="btn btn-outline-success btn-sm p-1 me-3"
                                                        onClick={() => {
                                                            const updated = guestItems.filter((_, i) => i !== index); // remove current item
                                                            setGuestItems(updated);
                                                        }}
                                                    >
                                                        <i className="bi bi-trash "></i>
                                                    </button>
                                                )
                                                }
                                                {item.name}</td>
                                            <td>{item.description}</td>
                                            <td>${parseFloat(item.rate).toFixed(2)}</td>
                                            <td>
                                                {!isPaid ?
                                                    <>
                                                        {!item.discount ? (
                                                            <button className="btn btn-outline-success btn-sm" onClick={() => openItemDiscountModal(index)}>
                                                                <i className="bi bi-plus-lg me-1"></i>Add Discount
                                                            </button>
                                                        ) : (
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="text-success fw-bold mb-0">${parseFloat(item.discount).toFixed(2)}</span>
                                                                <button className="btn btn-sm btn-outline-danger py-0 px-2" onClick={() => {
                                                                    const updated = [...guestItems];
                                                                    updated[index].discount = 0;
                                                                    setGuestItems(updated);
                                                                }}>
                                                                    <i className="bi bi-x-lg"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                    :
                                                    <span className="text-success fw-bold mb-0">${parseFloat(item.discount).toFixed(2)}</span>

                                                }
                                            </td>
                                            <td>${(item.rate - (item.discount || 0)).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>
                    </div>
                    {!isPaid &&
                        <div className="row g-4">

                            <div className="col-lg-6 fw-bold gap-1">
                                <select className="form-select" name="additional_item_id" value={selectedItemId} onChange={(e) => setSelectedItemId(e.target.value)}  >
                                    <option value="">--Additional Items--</option>
                                    {additionalItems.map(ai => (
                                        <option key={ai.id} value={ai.id}>
                                            {ai.name} (${(ai.rate).toFixed(2)})
                                        </option>
                                    ))}
                                </select>

                            </div>
                            <div className="col-lg-6  gap-2">
                                <button className="btn btn-dark" onClick={handleAddItem}>
                                    <i className="bi bi-plus"></i> Add
                                </button>
                            </div>


                        </div>

                    }



                </div>
            </div>

            <div className="card shadow mt-4">



                <div className="row g-3  m-4">
                    <div className="col-md-6 border-end border-dark-subtle mt-0 ">

                        <label class="form-label mb-4">Mode of Payment</label>
                        <div className="d-flex flex-direction-row mb-3" >
                            <div className="form-check me-3" onClick={(e) => setReview(prev => ({ ...prev, mode_of_payment: 'online' }))} disabled={isPaid} >
                                <input className="form-check-input" type="radio" name="mode_of_payment" id="modeOfPaymentOnline" value="online" checked={review?.mode_of_payment === "online"} disabled={isPaid} />
                                <label className=" form-check-label" htmlFor="invoiceEmail">Online</label>
                            </div>
                            <div className="form-check" onClick={(e) => setReview(prev => ({ ...prev, mode_of_payment: 'offline', is_recurring: 0 }))} disabled={isPaid} >
                                <input className="form-check-input" type="radio" name="mode_of_payment" id="modeOfPaymentOffline" value="offline" checked={review?.mode_of_payment === "offline"} disabled={isPaid} />
                                <label className=" form-check-label" htmlFor="invoicePrinted">Offline (Cash)</label>
                            </div>
                        </div>

                        {review?.mode_of_payment === "online" && (
                            <div className="form-check mt-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="is_recurring"
                                    id="is_recurring"
                                    value="1"
                                    checked={review?.is_recurring === 1}
                                    disabled={isPaid}
                                    onChange={(e) =>
                                        setReview((prev) => ({
                                            ...prev,
                                            is_recurring: e.target.checked ? 1 : 0, // store as 0/1
                                        }))
                                    }
                                />
                                <label className="form-check-label fw-bold" htmlFor="is_recurring">
                                    Enroll this card holder/account holder in autopay.
                                </label>
                            </div>
                        )}


                    </div>
                    <div className="col-md-6 mt-0">
                        <div className="px-2">
                            <div className="mb-4">
                                <label className="form-label">Amount Paid:</label>

                            </div>

                            <div className="row mb-3">
                                <div className="col">Subtotal:</div>
                                <div className="col text-end">${getTotalSubtotal()}</div>
                            </div>

                            <div className="row mb-3">
                                <div className="col">Discount:</div>
                                <div className="col text-end">${getTotalDiscount()}</div>
                            </div>

                            <div className="row mb-3">
                                <div className="col fw-bold">Total Amount Due:</div>
                                <div className="col text-end">
                                    ${(getTotalSubtotal() - getTotalDiscount()).toFixed(2)}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div className="card shadow mt-4">


                <div className="d-flex flex-wrap gap-3 justify-content-center py-4">

                    {/* Go Back */}
                    <button type="button" className="btn btn-lg btn-outline-dark" onClick={() => navigate(`/admin/guest-management/guest-intake-form-move-in-door/${review?.id}`)} >
                        Go Back
                    </button>


                    {!isPaid &&
                        <>
                            {/* Cancel & Discard */}
                            <button type="button" className="btn btn-lg btn-outline-danger" onClick={handleCancelAndDiscard} disabled={isDisabled}  >Cancel & Discard</button>
                            {/* Save & Next */}
                            <button type="button" className="btn btn-lg btn-dark" onClick={handleSaveAndNext} disabled={isDisabled}  >Save & Next</button>
                        </>
                    }

                </div>
            </div>



            {monthlyDiscountModalIndex !== null && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Discount for {monthlyRows[monthlyDiscountModalIndex]?.month}</h5>
                                <button type="button" className="btn-close" onClick={() => setMonthlyDiscountModalIndex(null)}></button>
                            </div>
                            <div className="modal-body">
                                <input
                                    type="number"
                                    min={0}
                                    className="form-control"
                                    value={monthlyDiscountValue}
                                    onChange={(e) => setMonthlyDiscountValue(e.target.value)}
                                />
                                <small className="text-muted mt-1 d-block">
                                    This amount is in <strong>USD ($)</strong>.
                                </small>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setMonthlyDiscountModalIndex(null)}>Cancel</button>
                                <button className="btn btn-primary" onClick={applyMonthlyDiscount}>Apply</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {showItemDiscountModal && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Discount</h5>
                                <button type="button" className="btn-close" onClick={() => setShowItemDiscountModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <input
                                    type="number"
                                    min={0}
                                    className="form-control"
                                    value={discountValue}
                                    onChange={(e) => setDiscountValue(e.target.value)}
                                    placeholder="Enter discount"
                                />
                                <small className="text-muted mt-1 d-block">
                                    This amount is in <strong>USD ($)</strong>.
                                </small>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowItemDiscountModal(false)}>Cancel</button>
                                <button className="btn btn-primary" onClick={applyItemDiscount}>Apply</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* ===== STRIPE PAYMENT MODAL ===== */}
            {showStripeModal && stripePromise && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg  modal-dialog-centered">
                        <div className="modal-content bg-light">
                            <div className="modal-header">
                                <h5 className="modal-title">Online Payment</h5>
                                <button type="button"  className="btn-close"   onClick={() => setShowStripeModal(false)}   />
                            </div>

                            <div className="modal-body">
                                <Elements stripe={stripePromise}>
                                   
                                    <StripePaymentModal stripeModalData={stripeModalData} onSuccess={handleStripeSuccess} onCancel={() => setShowStripeModal(false)} />
                                </Elements>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>


    );
};

export default GuestIntakeFormReview;
